import Bets from './Bets';
export default Bets;